import { Component} from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'forecast-reset',
  templateUrl: './forecast-reset.component.html',
  styleUrls: ['./forecast-reset.component.scss']

})
export class ForecastResetComponent  {
  
  constructor(public dialogRef: MatDialogRef<ForecastResetComponent>) {
  }
  
  ngOnInit() {
  }

  onConfirmDeleteClick() {
    this.dialogRef.close({ data: { goAhead: true } });
}
}